import React, { useState } from "react";
import "./NextMove.css";

const NextMove = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const items = [
    {
      index: "01",
      title: "Explorează Portofoliul",
      descr:
        "Inspiră-te din proiectele noastre anterioare. Vezi diversitatea de soluții pe care le-am construit și imaginează-ți posibilitățile pentru afacerea ta.",
    },
    {
      index: "02",
      title: "Definește-ți Viziunea",
      descr:
        "Gândește-te la obiectivele tale. Ce problemă vrei să rezolvi? Ce funcționalități sunt esențiale? O idee clară ne ajută să construim soluția potrivită.",
    },
    {
      index: "03",
      title: "Programează o Discuție",
      descr:
        "Contactează-ne pentru o sesiune de consultanță gratuită. Vom discuta ideile tale în detaliu și vom explora cele mai bune căi de a le transforma în realitate.",
    },
    {
      index: "04",
      title: "Primește Oferta Personalizată",
      descr:
        "Pe baza discuției, îți vom pregăti o ofertă detaliată, transparentă, care va include etapele proiectului, tehnologiile folosite și costurile implicate.",
    },
    {
      index: "05",
      title: "Pornim Proiectul Împreună",
      descr:
        "Odată ce accepți oferta, echipa noastră se apucă de treabă. Te vom ține la curent pe parcursul întregului proces, de la design la lansare.",
    },
  ];

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="nextmove">
      <div className="sub-title">
        <h2 className="text-2">
          <span className="">Următorul Tău Pas</span>
        </h2>
        {/* <p className="p-1">
          Iată pașii concreți pe care îi vom urma împreună pentru a transforma
          ideile tale în soluții digitale performante:
        </p> */}
      </div>
      <div className="accordion">
        <div className="items">
          {items.map((item) => (
            <div
              key={item.index}
              className={`item ${activeIndex === item.index ? "active" : ""}`}
              onClick={() => handleToggle(item.index)}
            >
              <div className="title">
                <div>
                  <div className="item-index">{item.index}</div>
                  <h3 className="item-title">{item.title}</h3>
                </div>
                <div className="item-btn">+</div>
              </div>
              <p className="item-desc">{item.descr}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NextMove;
